<template>
    <div
        v-if="index === 0"
        :v-else="overstapCountInc"
        class="floatleft width100"
        :style="!first ? 'margin-top: 10px;' : ''"
    >
        <div class="flightlogo">
            <flightLogo :flightNumber="flight.flightNumber" />
        </div>

        <div
            class="flighttitle floatleft width85 padding5"
            style="padding-left: 0 !important;"
        >
            <div style="color:#333" class="marginleft15">
                <div style="float:left;width:8%; margin: 10px; color: #333">
                    <font-awesome-icon
                        icon="plane"
                        :flip="first ? 'horizontal' : ''"
                    />
                </div>
                <div style="float:left; width: calc(92% - 20px);">
                    <strong>
                        {{ flight.departureAirport }} -
                        {{ flight.arrivalAirport }} -
                        {{ moment(flight.departureDate).format('LL') }} </strong
                    ><br />
                    <div
                        class="plane2"
                        style="float:left;width:8%; margin: 10px; color: #333;"
                    >
                        <font-awesome-icon
                            icon="plane"
                            :flip="first ? 'horizontal' : ''"
                        />
                    </div>
                    <span>
                        Vertrek:
                        {{ moment(flight.departureDate).format('dd. HH:mm') }}
                        - Aankomst:
                        {{ moment(flight.arrivalDate).format('dd. HH:mm') }}
                    </span>
                </div>
            </div>
        </div>

        <div class="floatleft width100 font10" style="text-align: center;">
            <div class="clear"></div>
            <div
                class="flightbagage floatleft width100"
                style="text-align: right; color:#333; font-size: 10px; width:100% !important;"
            >
                <font-awesome-icon style="margin-right: 4px;" icon="info" />
                {{ this.overstapcount }}x Overstap

              <div v-if="this.flight.carriercode === 'HV' || this.flight.carriercode === 'TO'">
                <font-awesome-icon icon="suitcase" />
                Incl. klein handbagage &nbsp;
              </div>

              <div v-else="">
                <font-awesome-icon icon="suitcase" />
                Incl. handbagage &nbsp;
              </div>

              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512" style="margin-left:24px; margin-right: 4px;" width="13" height="13"><!--!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.--><path d="M336 160H48c-26.5 0-48 21.5-48 48v224c0 26.5 21.5 48 48 48h16v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h128v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h16c26.5 0 48-21.5 48-48V208c0-26.5-21.5-48-48-48zm-16 216c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zm0-96c0 4.4-3.6 8-8 8H72c-4.4 0-8-3.6-8-8v-16c0-4.4 3.6-8 8-8h240c4.4 0 8 3.6 8 8v16zM144 48h96v80h48V48c0-26.5-21.5-48-48-48h-96c-26.5 0-48 21.5-48 48v80h48V48z"/></svg>
              Excl. ruimbagage (achteraf bij te boeken)
            </div>
        </div>

        <div class="clear marginbottom10"></div>
    </div>
</template>

<script>
import FlightLogo from './FlightLogo.vue'

export default {
    name: 'FlightCached',
    components: {
        FlightLogo,
    },
    props: {
        flight: Object,
        index: Number,
        first: Boolean,
    },
    data: function() {
        return { overstapcount: 0 }
    },
    methods: {
        overstapCountInc: function() {
            this.overstapcount += 1
        },
    },
}
</script>

<style scoped>
.plane2 {
    display: none !important;
}
.flightlogo {
    float: left;
    margin-top: 15px;
}
@media screen and (max-width: 900px) {
    .vluchtenoverzicht .flightlogo {
        width: 100%;
        margin: 5px auto;
    }
}
</style>
